import React from 'react';
import { Redirect, useLocalSearchParams } from 'expo-router';
export default function LearnLessonRedirect() {
  const { slug, ...params } = useLocalSearchParams();
  const name = Array.isArray(slug) ? slug[0] : slug;
  if (!name || name === 'index') return <Redirect href="/docs#learn" />;
  return <Redirect href={{ pathname: '/docs/learn/[slug]', params: { ...params, slug: name } }} />;
}
